<div class="dialogue-content">
    <mat-dialog-content>
      <div class="text-center">
        <form novalidate>
          <img src="assets/images/refresh.svg" class="mb-4 m-auto d-table" />
          <p>Are you sure you want to save and send this notification?</p>
          <div class="d-flex align-items-center mt-4 flex-nowrap justify-content-center gap-3">
            <button matButton="filled" class="btn dialog-btn-secondary" (click)="cancel()">No</button>
            <button matButton="filled" type="button" class="btn dialog-btn-primary" (click)="confirm()">Yes</button>
          </div>
        </form>
      </div>
    </mat-dialog-content>
  </div>
  